export default __webpack_public_path__ + "images/VX.0da6178.png";